import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { addFirewallAsync } from "./AddFirewallAsync";
import { Firewall } from "../../../api/controlPlaneApi";
import { MinioFirewallConfigData } from "../../../api/firewallApi";

export interface IAddFirewall {
  addFirewallLoading: boolean;
  selectedSite: string;
  name: string;
  namespace: string;
  hideNamespace: boolean;
  configData: MinioFirewallConfigData;
  firewallProcessed: Firewall | null;
  tenantReference?: string | null;
}

const initialState: IAddFirewall = {
  addFirewallLoading: false,
  selectedSite: "",
  name: "",
  namespace: "",
  hideNamespace: false,
  configData: {
    server: {
      address: {
        s3: ":8000",
        console: ":8002",
        health: "/minio/health/ready",
      },
    },
    minio: {
      health: {
        interval: "10s",
      },
    },
  },
  firewallProcessed: null,
  tenantReference: null,
};

export const addFirewallSlice = createSlice({
  name: "addFirewall",
  initialState,
  reducers: {
    setAddFirewallLoading: (state, action: PayloadAction<boolean>) => {
      state.addFirewallLoading = action.payload;
    },
    setFirewallSelectedSite: (state, action: PayloadAction<string>) => {
      state.selectedSite = action.payload;
    },
    setFirewallName: (state, action: PayloadAction<string>) => {
      state.name = action.payload;
    },
    setFirewallNamespace: (state, action: PayloadAction<string>) => {
      state.namespace = action.payload;
    },
    hideFirewallNamespace: (state) => {
      state.hideNamespace = true;
    },
    setFirewallConfigData: (
      state,
      action: PayloadAction<MinioFirewallConfigData>,
    ) => {
      state.configData = action.payload;
    },
    setTenantReference: (state, action: PayloadAction<string | null>) => {
      state.tenantReference = action.payload;
    },
    resetAddFirewallForm: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addFirewallAsync.pending, (state) => {
        state.addFirewallLoading = true;
      })
      .addCase(addFirewallAsync.rejected, (state) => {
        state.addFirewallLoading = false;
      })
      .addCase(addFirewallAsync.fulfilled, (state, action) => {
        state.addFirewallLoading = false;
        state.firewallProcessed = action.payload;
      });
  },
});

export const {
  setAddFirewallLoading,
  resetAddFirewallForm,
  setFirewallSelectedSite,
  setFirewallName,
  setFirewallNamespace,
  setFirewallConfigData,
  hideFirewallNamespace,
  setTenantReference,
} = addFirewallSlice.actions;

export default addFirewallSlice.reducer;
